import axios from "axios";
import queryString from "query-string";
import { errorNoti } from "../../base/BasicNotifications";
import { sharedReduxSlice } from "./sharedSlice";
import { SharedUrls } from "./sharedUrls";
import { getCookie } from "../../utils/cookieUtils";
import { ACCESS_TOKEN_COOKIE_KEY, ADMIN_ACCESS_TOKEN_COOKIE_KEY, ADMINS_COACH_ID_COOKIE_KEY } from "../../data/enums/TokenEnums";

const { actions } = sharedReduxSlice;

const AppInstance = axios.create({ baseURL: "" });
const nodeInstance = axios.create({ baseURL: process.env.REACT_APP_NEST_BASE_URL });


//Add a middleware in Node instance to add the sme_id to the headers
nodeInstance.interceptors.request.use((config) => {  
  //Fetch token from cookies 
  let accessToken = getCookie(ACCESS_TOKEN_COOKIE_KEY);
  let adminAccessToken = getCookie(ADMIN_ACCESS_TOKEN_COOKIE_KEY);
  let adminsCoachId = getCookie(ADMINS_COACH_ID_COOKIE_KEY);
  let isAdminDetailSufficient = adminAccessToken && adminsCoachId;
  if(isAdminDetailSufficient){    
    if(config.params){
      config.params["coach_id"] = adminsCoachId;
    }else{
      config.params = {
        coach_id: adminsCoachId
      }
    }
  }  
  return config;
});

const GLOASSARYWORDS_URL = "/GloassaryWords.json";

export const getGloassaryWords = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    AppInstance
      .get(GLOASSARYWORDS_URL)
      .then((response) => {
        resolve(response.data.data);
        dispatch(actions.setGloassaryWords(response.data.data));
      })
      .catch((err) => {
        resolve(false);
        errorNoti(err.response.data.message);
      });
  });
};

export const getCountryList = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    nodeInstance
      .get(SharedUrls.GET_COUNTRIES)
      .then((response) => {
        resolve(response.data);
        dispatch(actions.setCountryList(response.data.data));
      })
      .catch((err) => {
        resolve(false);
        errorNoti(err.response.data.message);
      });
  });
};

export const getBillingDetails = () => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    let url = SharedUrls.BILLING_DETAILS;
    nodeInstance
      .get(url, {
        headers: {
          Authorization: getState().authDetails.accessToken,
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        console.log(err);
        resolve(false);
        errorNoti(err.response.data.message);
      });
  });
};

export const updateBillingDetails = (data) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    let url = SharedUrls.BILLING_DETAILS;
    nodeInstance
      .post(url, data, {
        headers: {
          Authorization: getState().authDetails.accessToken,
        },
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        resolve(false);
        errorNoti(err.response.data.message);
      });
  });
}